// src/services/surchargeApiSlice.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithRefreshTokenHandler } from '../authFetchBaseQuery';
import { CreateWebHookSubscriberRequest, performHealthCheckRequest, CreateWebHookSecretRequest, UpdateSubscriberStatusRequest, ModifyWebHookSubscriberRequest } from '../../types/WebHookTypes';
import {  API_GENERIC_WNF_SUBSCRIBERS, API_GET_WNF_EVENTS, API_POST_WNF_HEALTH_CHECK_PING, API_POST_CREATE_SECRET, API_POST_GET_ALL_WEBHOOK_SUBSCRIBERS, API_PUT_UPDATE_SUBSCRIBER_STATUS  } from '../ApiConstants';
import { PaginationSearchSortingType } from '../../types/types';

export const webHookApiSlice = createApi({
  reducerPath: "webHookApiSlice",
  baseQuery: baseQueryWithRefreshTokenHandler,
  tagTypes: ["WebHookConfigurations"],
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getAllEvents: builder.query({
      query: () => {
        return {
          url: API_GET_WNF_EVENTS,
          method: "GET",
        };
      },
    }),

    createWebHookSubscriber: builder.mutation<
      any,
      CreateWebHookSubscriberRequest
    >({
      query: (request: CreateWebHookSubscriberRequest) => {
        return {
          url: API_GENERIC_WNF_SUBSCRIBERS,
          method: "POST",
          body: request,
        };
      },
    }),

    performWebHookHealthCheck: builder.mutation<any, performHealthCheckRequest>(
      {
        query: (request: performHealthCheckRequest) => {
          return {
            url: API_POST_WNF_HEALTH_CHECK_PING,
            method: "POST",
            body: request,
          };
        },
      }
    ),

    createWebHookSecret: builder.mutation<any, CreateWebHookSecretRequest>({
      query: (request: CreateWebHookSecretRequest) => {
        return {
          url: API_POST_CREATE_SECRET,
          method: "POST",
          body: request,
        };
      },
    }),

    getAllWebhookConfigurations: builder.query({
      query: (request: PaginationSearchSortingType) => {
        return {
          url: API_POST_GET_ALL_WEBHOOK_SUBSCRIBERS,
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      providesTags: ["WebHookConfigurations"],
    }),

    deleteWebhookConfigurations: builder.mutation<any, string>({
      query: (request: string) => {
        return {
          url: API_GENERIC_WNF_SUBSCRIBERS + "/" + request,
          method: "DELETE",
        };
      },
      invalidatesTags: ['WebHookConfigurations'],
    }),

    updateWebhookStatus: builder.mutation<any, UpdateSubscriberStatusRequest>({
      query: (request: UpdateSubscriberStatusRequest) => {
        return {
          url: API_PUT_UPDATE_SUBSCRIBER_STATUS + "/" + request.id + "/" + request.status,
          method: "PUT",
        };
      },
      invalidatesTags: ['WebHookConfigurations'],
    }),

    getWebhookConfigurationById: builder.query<any, string>({
      query: (request: string) => {
        return {
          url: API_GENERIC_WNF_SUBSCRIBERS + "/" + request,
          method: "GET",
        };
      },
    }),

    updatedWebHookSubscriber: builder.mutation<any, ModifyWebHookSubscriberRequest>({
      query: (request: ModifyWebHookSubscriberRequest) => {
        return {
          url: API_GENERIC_WNF_SUBSCRIBERS + "/" + request.id,
          method: "PUT",
          body: request,
        };
      }
    }),

  }),
});

// Export hooks generated by RTK Query for component usage
export const {
    useCreateWebHookSubscriberMutation,
    useGetAllEventsQuery,
    usePerformWebHookHealthCheckMutation,
    useCreateWebHookSecretMutation,
    useGetAllWebhookConfigurationsQuery,
    useDeleteWebhookConfigurationsMutation,
    useUpdateWebhookStatusMutation,
    useGetWebhookConfigurationByIdQuery,
    useUpdatedWebHookSubscriberMutation
} = webHookApiSlice;
